import React from 'react'
import PropTypes from 'prop-types'
import { LocalizedText, LabeledTextarea, ConfirmModal, useHandler } from 'labguard-cdk'

const AddCommentModal = ({ inputMessage, children, required, onConfirm, ...props }) => {
  const [comment, onCommentChange] = React.useState('')
  const enhancedOnConfirm = useHandler(() => onConfirm && onConfirm(comment))
  const canConfirm = !required || !!(required && comment && Boolean(comment.trim()))
  return (
    <ConfirmModal {...props} onConfirm={enhancedOnConfirm} canConfirm={canConfirm}>
      <LabeledTextarea
        topLabel={inputMessage}
        value={comment}
        onChange={onCommentChange}
        style={{ resize: 'none', minHeight: '10vh' }}
      />
      {children}
    </ConfirmModal>
  )
}

AddCommentModal.defaultProps = {
  title: <LocalizedText id="WEB_COMMENT" />,
  inputMessage: <LocalizedText id="WEB_ADD_COMMENT" />,
}

AddCommentModal.propTypes = {
  inputMessage: PropTypes.node,
  required: PropTypes.bool,
  onConfirm: PropTypes.func,
  children: PropTypes.node,
}

export default AddCommentModal
